import { InstitutionUisIdentitySettingDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class AuthenticationIdentitySettings extends DomainEntity<InstitutionUisIdentitySettingDto> {
    public static from(dto: InstitutionUisIdentitySettingDto): AuthenticationIdentitySettings {
        return new AuthenticationIdentitySettings(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get uisSecurityLevelId() {
        return this.dto.uisSecurityLevelId;
    }

    public set uisSecurityLevelId(value: number | undefined) {
        this.dto.uisSecurityLevelId = value;
    }
}
